"use client";
import { type ReactNode, useCallback, useEffect, useRef, useState } from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "ui/iconsN";

const WIDTH = 384;

type Props = {
  children: ReactNode;
};
export const CarouselInner = ({ children }: Props) => {
  const [showButtons, setShowButtons] = useState(true);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);
  const ref = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);

  const handlePrevious = useCallback(() => {
    innerRef.current?.scrollBy(-WIDTH, 0);

    if ((innerRef.current?.scrollLeft || 0) <= WIDTH + 16) {
      setShowLeft(false);
    }

    setShowRight(true);
  }, []);

  const handleNext = useCallback(() => {
    innerRef.current?.scrollBy(WIDTH, 0);

    if (
      (innerRef.current?.scrollWidth || 0) - (ref.current?.clientWidth || 0) - (innerRef.current?.scrollLeft || 0) <=
      WIDTH
    ) {
      setShowRight(false);
    }

    setShowLeft(true);
  }, []);

  useEffect(() => {
    const showButtons = (innerRef.current?.scrollWidth || 0) > (ref.current?.clientWidth || 0);
    setShowButtons(showButtons);
  }, []);

  return (
    <div ref={ref} className="relative">
      <div
        ref={innerRef}
        className="flex gap-4 items-start py-8 snap-x snap-mandatory scroll-smooth overflow-x-scroll overflow-y-hidden no-scrollbar overscroll-x-contain"
      >
        {children}
      </div>
      {showButtons && (
        <>
          {showLeft && (
            <div
              className="group absolute left-0 top-1/2 -translate-y-1/2 z-3 bg-tx-1/90 hover:bg-tx-1 w-12 h-24 cursor-pointer rounded-r-full md:flex justify-center items-center backdrop-blur-xs border-[1.5px] border-l-0 border-transparent shadow-[0_0_16px_0_rgba(0,0,0,0.24)] hover:border-pr-1 hover:shadow-[0_0_24px_0_rgba(185,87,51,0.70)] transition-all hidden select-none"
              onClick={handlePrevious}
            >
              <ArrowLeftIcon className="w-6 h-6 group-hover:-translate-x-1 transition-transform text-white" />
            </div>
          )}
          {showRight && (
            <div
              className="group absolute right-0 top-1/2 -translate-y-1/2 z-3 bg-tx-1/90 hover:bg-tx-1 w-12 h-24 cursor-pointer rounded-l-full md:flex justify-center items-center backdrop-blur-xs border-[1.5px] border-r-0 border-transparent shadow-[0_0_16px_0_rgba(0,0,0,0.24)] hover:border-pr-1 hover:shadow-[0_0_24px_0_rgba(185,87,51,0.70)] transition-all hidden select-none"
              onClick={handleNext}
            >
              <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform text-white" />
            </div>
          )}
        </>
      )}
    </div>
  );
};
